import type { ComponentDefinition } from "../types";

// Sources and model boundaries: docs/research/common-batteries-2026-10-28.md.
// Unpublished charge/discharge limits stay absent; terminal maxAmp=0 means unknown.
export const COMMON_BATTERIES: ComponentDefinition[] = [
  {
    "id": "batt-exide-em1000",
    "name": "Exide Start AGM EM1000 50Ah",
    "shortName": "EM1000 AGM",
    "subtitle": "Marine starter battery",
    "category": "battery",
    "manufacturer": "Exide",
    "model": "EM1000",
    "voltage": 12,
    "capacityAh": 50,
    "chemistry": "agm",
    "coldCrankingAmps": 800,
    "marineCrankingAmps": 1000,
    "width": 210,
    "height": 80,
    "terminals": [
      {
        "id": "pos",
        "label": "+",
        "polarity": "positive",
        "direction": "bidi",
        "side": "left",
        "offset": 0.5,
        "maxAmp": 0
      },
      {
        "id": "neg",
        "label": "−",
        "polarity": "negative",
        "direction": "bidi",
        "side": "right",
        "offset": 0.5,
        "maxAmp": 0
      }
    ]
  },
  {
    "id": "batt-exide-en800",
    "name": "Exide Start EN800 90Ah",
    "shortName": "EN800 90Ah",
    "subtitle": "Flooded marine starter battery",
    "category": "battery",
    "manufacturer": "Exide",
    "model": "EN800",
    "voltage": 12,
    "capacityAh": 90,
    "chemistry": "lead-acid",
    "coldCrankingAmps": 720,
    "marineCrankingAmps": 800,
    "width": 210,
    "height": 80,
    "terminals": [
      {
        "id": "pos",
        "label": "+",
        "polarity": "positive",
        "direction": "bidi",
        "side": "left",
        "offset": 0.5,
        "maxAmp": 0
      },
      {
        "id": "neg",
        "label": "−",
        "polarity": "negative",
        "direction": "bidi",
        "side": "right",
        "offset": 0.5,
        "maxAmp": 0
      }
    ]
  },
  {
    "id": "batt-exide-ep800",
    "name": "Exide Dual AGM EP800 95Ah",
    "shortName": "EP800 AGM 95Ah",
    "subtitle": "Marine / RV / campervan dual-purpose battery",
    "category": "battery",
    "manufacturer": "Exide",
    "model": "EP800",
    "voltage": 12,
    "capacityAh": 95,
    "chemistry": "agm",
    "coldCrankingAmps": 850,
    "width": 210,
    "height": 80,
    "terminals": [
      {
        "id": "pos",
        "label": "+",
        "polarity": "positive",
        "direction": "bidi",
        "side": "left",
        "offset": 0.5,
        "maxAmp": 0
      },
      {
        "id": "neg",
        "label": "−",
        "polarity": "negative",
        "direction": "bidi",
        "side": "right",
        "offset": 0.5,
        "maxAmp": 0
      }
    ]
  },
  {
    "id": "batt-exide-es900",
    "name": "Exide Equipment GEL ES900 80Ah",
    "shortName": "ES900 GEL 80Ah",
    "subtitle": "Marine / RV / campervan gel house battery",
    "category": "battery",
    "manufacturer": "Exide",
    "model": "ES900",
    "voltage": 12,
    "capacityAh": 80,
    "chemistry": "gel",
    "width": 210,
    "height": 80,
    "terminals": [
      {
        "id": "pos",
        "label": "+",
        "polarity": "positive",
        "direction": "bidi",
        "side": "left",
        "offset": 0.5,
        "maxAmp": 0
      },
      {
        "id": "neg",
        "label": "−",
        "polarity": "negative",
        "direction": "bidi",
        "side": "right",
        "offset": 0.5,
        "maxAmp": 0
      }
    ]
  },
  {
    "id": "batt-interstate-srm27",
    "name": "Interstate SRM-27 88Ah Deep Cycle",
    "shortName": "SRM-27 88Ah",
    "subtitle": "Flooded marine / RV house battery",
    "category": "battery",
    "manufacturer": "Interstate",
    "model": "SRM-27",
    "voltage": 12,
    "capacityAh": 88,
    "chemistry": "lead-acid",
    "coldCrankingAmps": 600,
    "width": 210,
    "height": 80,
    "terminals": [
      {
        "id": "pos",
        "label": "+",
        "polarity": "positive",
        "direction": "bidi",
        "side": "left",
        "offset": 0.5,
        "maxAmp": 0
      },
      {
        "id": "neg",
        "label": "−",
        "polarity": "negative",
        "direction": "bidi",
        "side": "right",
        "offset": 0.5,
        "maxAmp": 0
      }
    ]
  },
  {
    "id": "batt-varta-a5-agm",
    "name": "VARTA Dynamic AGM A5 95Ah",
    "shortName": "VARTA A5 AGM",
    "subtitle": "RV / campervan chassis starter battery",
    "category": "battery",
    "manufacturer": "VARTA",
    "model": "A5 / 595901085 (019AGM)",
    "voltage": 12,
    "capacityAh": 95,
    "chemistry": "agm",
    "coldCrankingAmps": 850,
    "width": 210,
    "height": 80,
    "terminals": [
      {
        "id": "pos",
        "label": "+",
        "polarity": "positive",
        "direction": "bidi",
        "side": "left",
        "offset": 0.5,
        "maxAmp": 0
      },
      {
        "id": "neg",
        "label": "−",
        "polarity": "negative",
        "direction": "bidi",
        "side": "right",
        "offset": 0.5,
        "maxAmp": 0
      }
    ]
  }
];
